import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMiljogebyrKopi as getMiljogebyrKopiAction } from "../../../../actions/miljogebyrerActions";
import LoadButton from "../../LoadButton";

export default function KopiContainer() {
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const dispatch = useDispatch();
  const [showKopiSpinner, setShowKopiSpinner] = useState(false);

  const onClickHandler = () => {
    setShowKopiSpinner(true);
    dispatch(
      getMiljogebyrKopiAction(miljogebyr.id, miljogebyr.ileggelsesnummer),
    )
      .then(() => setShowKopiSpinner(false))
      .catch(() => setShowKopiSpinner(false));
  };

  return (
    <LoadButton
      isLoading={showKopiSpinner}
      buttonProps={{
        className: "btn btn-bym-standard",
        style: { marginRight: 20 },
        onClick: onClickHandler,
        disabled: showKopiSpinner,
      }}
      spinnerProps={{ pColor: "#ffffff", sColor: "#4d4d4d" }}
    >
      Kopi av miljøgebyr
    </LoadButton>
  );
}
